import {useMemo} from 'react';

import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';

export const getRefundTips = (t, autoRefundPolicy, isHost) => {
  if (autoRefundPolicy === 0) {
    return {
      label: t('payment.alwaysRefund'),
      desc: t('payment.freeCancellationOrReschedulingAtAnyTime'),
    };
  }
  if (autoRefundPolicy === -1) {
    return {
      label: t('payment.doNotAutomaticallyRefund'),
      desc: t(isHost? 'payment.manageRefundsManually' : 'payment.noAutoRefund'),
    };
  }
  if (autoRefundPolicy > 0) {
    const duration = autoRefundPolicy > 24 ?
      t('payment.days', {count: autoRefundPolicy / 24}) :
      t('payment.hours', {count: autoRefundPolicy});
    return {
      label: t('payment.durationBefore', {duration}),
      desc: t('payment.freeCancellationOrReschedulingBeforeEventStarts', {duration}),
    };
  }
  return {label: '', desc: ''};
};

const useRefundTips = (autoRefundPolicy) => {
  const {t} = useTranslation();
  const autoRefundPolicyStore = useSelector((s) => s.bookAppointments.autoRefundPolicy);
  const policy = autoRefundPolicy ?? autoRefundPolicyStore;
  const refundTips = useMemo(() => getRefundTips(t, policy).desc, [t, policy]);
  return refundTips;
};

export default useRefundTips;
